import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faMinus, faPen } from "@fortawesome/pro-regular-svg-icons";
import { FormInput } from "@/components/form";
import { StatusChip } from "@/components/status-chip";
import { getTaskDisplayProps } from "@/components/patient-tasks";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Header bar of the task detail panel: status chip, title (text + pencil, or input + revert) and window controls. */
export function TaskDetailHeader(_ref) {
  var reminder = _ref.reminder,
    title = _ref.title,
    isEditing = _ref.isEditing,
    onStartEdit = _ref.onStartEdit,
    onTitleChange = _ref.onTitleChange,
    onRevertTitle = _ref.onRevertTitle,
    onMinimize = _ref.onMinimize,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _getTaskDisplayProps = getTaskDisplayProps(reminder),
    intent = _getTaskDisplayProps.intent,
    label = _getTaskDisplayProps.label;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-3 px-5 py-4 border-b border-sds-base-default flex-shrink-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 items-center gap-3 min-w-0"
  }, /*#__PURE__*/React.createElement(StatusChip, {
    intent: intent,
    label: label
  }), isEditing ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 items-center gap-2 min-w-0"
  }, /*#__PURE__*/React.createElement(FormInput, {
    "data-testid": "task-detail-title-input",
    value: title,
    autoFocus: true,
    onChange: function onChange(e) {
      return onTitleChange(e.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_TITLE_INPUT, {
        taskId: reminder.id
      });
    },
    classNames: {
      root: "w-1/2 min-w-0",
      wrapper: "w-full"
    }
  }), /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-detail-title-revert",
    "aria-label": t("revert", {
      defaultValue: "Revert"
    }),
    title: t("revert", {
      defaultValue: "Revert"
    }),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_TITLE_DISCARD, {
        taskId: reminder.id
      });
      onRevertTitle();
    },
    className: "flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-sds-100 text-sds-base-secondary hover:bg-sds-base-secondary hover:text-sds-base-default transition-colors"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faXmark,
    className: "w-3.5 h-3.5"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1.5 min-w-0 group/title"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-base-strong text-sds-base-default truncate ".concat(reminder.resolved ? "line-through" : "")
  }, title), /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-detail-title-edit",
    "aria-label": t("edit"),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_TITLE_EDIT, {
        taskId: reminder.id
      });
      onStartEdit();
    },
    className: "flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-sds-100 text-sds-base-tertiary hover:text-sds-base-default opacity-0 group-hover/title:opacity-100 transition-opacity"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPen,
    className: "w-3 h-3"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-shrink-0 items-center gap-1"
  }, onMinimize ? /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-detail-minimize",
    "aria-label": t("minimize", {
      defaultValue: "Minimise"
    }),
    title: t("minimize", {
      defaultValue: "Minimise"
    }),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_MINIMIZE, {
        taskId: reminder.id
      });
      onMinimize();
    },
    className: "flex w-7 h-7 items-center justify-center rounded-sds-100 text-sds-base-secondary hover:bg-sds-base-secondary hover:text-sds-base-default transition-colors"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faMinus,
    className: "w-5 h-5"
  })) : null, /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-detail-close",
    "aria-label": t("close"),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_CLOSE, {
        taskId: reminder.id
      });
      onClose();
    },
    className: "flex w-7 h-7 items-center justify-center rounded-sds-100 text-sds-base-secondary hover:bg-sds-base-secondary hover:text-sds-base-default transition-colors"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faXmark,
    className: "w-5 h-5"
  }))));
}